'use es6';

import PropTypes from 'prop-types';
import { memo } from 'react';
import DashedLabel from '../../atoms/DashedLabel';
import { getTimestamp } from 'conversations-message-history/dates/operators/getters';
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import VizExSmall from 'visitor-ui-component-library/typography/VizExSmall';
import { jsx as _jsx } from "react/jsx-runtime";
const DateLabelMessage = /*#__PURE__*/memo(({
  message,
  labelPadding,
  locale
}) => {
  const timestamp = getTimestamp(message);
  const translatedDate = new Date(timestamp).toLocaleDateString(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  return /*#__PURE__*/_jsx(DashedLabel, {
    labelPadding: labelPadding,
    children: /*#__PURE__*/_jsx(VizExSmall, {
      use: "help",
      children: translatedDate
    })
  });
});
DateLabelMessage.displayName = 'DateLabelMessage';
DateLabelMessage.propTypes = {
  labelPadding: PropTypes.string,
  locale: PropTypes.string.isRequired,
  message: RecordPropType('DateMessage').isRequired
};
export default DateLabelMessage;